/* eslint-disable */

import React, { Component, Fragment } from 'react'
import Button from '@material-ui/core/Button'
import gql from 'graphql-tag'
import { withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import Select from 'react-select'
import CircularProgress from '@material-ui/core/CircularProgress'
import axios from 'axios'
import getLoginId from '../../../utils/getLoginId'
import MUIDataTable from 'mui-datatables'
import FormControl from '@material-ui/core/FormControl'
import FileSaver from 'file-saver'

import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormLabel from '@material-ui/core/FormLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'

// const style = theme => ({
//   root: {
//     padding: theme.spacing.unit * 2,
//     flexGrow: 1
//   }
// })

// const GET_PARTNER_CLIENT_LIST = gql`
//   query allClientDetails($status: Int, $superAdmin: Boolean) {
//     clients: allClientDetails(status: $status, superAdmin: $superAdmin) {
//       loginId
//       clientName
//     }
//   }
// `

const GET_PARTNER_CLIENT_LIST = gql`
  query allClientDetails($partnerLoginId: Int) {
    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {
      clientName
      loginId
    }
  }
`

const GET_ALL_VEHICLES = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    getAllVehicleDetails(clientLoginId: $clientLoginId) {
      entityId
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`

const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

const ADD_VEHICLES = gql`
  mutation excelFileUpload(
    $fileInfo: FileUploadInput!
    $commonInput: CommonInput!
  ) {
    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {
      failedToUpload
      totalExcelDataRecords
      totalDuplicateRecords
      successfullyUploaded
      failedUploadList
    }
  }
`

const GET_CALIBRATION_DETAILS = gql`
  query getFuelCalibrationDetail($entityId: Int) {
    getFuelCalibrationDetail(vehicleId: $entityId) {
      refuelThreshold
      drainThreshold
      medianFilter
      fuelUserType
      fuelSensorType
      minTankCapacity
      minValue
      maxTankCapacity
      totalFuelTank
      maxValue
      pfPerMin
      pilferageTolerance
      minimumPilferageDuration
      calibration_filename
      url
    }
  }
`
const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  }
})

class FuelCalibration extends Component {
  state = {
    client: { value: null, label: null },
    isUploading: false,
    fileName: '',
    bucketName: '',
    publicUploadURL: '',
    response: '',
    uploadSucess: true,
    result: false,
    failList: '',
    isLoading: false,

    response: '',
    clientNames: [],
    clientname: '',
    vehicleDetails: [],
    vehicleNumber: '',
    minValue: '',
    maxValue: '',
    minCapacity: '',
    maxCapacity: '',
    totalFuelTank: '',
    sensorType: 'Digital_sensor',
    isminCapacityValid: true,
    ismaxCapacityValid: true,
    isTotalFuelTankValid: true,
    isminValueValid: true,
    ismaxValueValid: true,
    refuelThreshold: '3',
    drainThreshold: '0.5',
    medianFilter: '10',
    pfPerMin: '3',
    pilferageTolerance: '10',
    minimumPilferageDuration: '30',
    userType: '0',
    downloadUrl: ''
  }
  //   columns = ['Serial Number', 'Reason']

  //   options = {
  //     selectableRows: false,
  //     responsive: 'scroll',
  //     rowsPerPage: 15

  // sort: false,
  // filter: false,
  //  search: false,
  // print: false,
  // download: false
  // viewColumns: false,
  // pagination: false

  handleClientChange = async event => {
    this.setState({ clientname: event.value })
    const {
      data: vehicle,
      error: vehicleError
    } = await this.props.client.query({
      query: GET_ALL_VEHICLES,
      variables: { clientLoginId: event.value },
      errorPolicy: 'all',
      fetchPolicy: 'network-only'
    })
    // console.log(vehicle, 'vehicle')
    const allVehicles = vehicle.getAllVehicleDetails.map(vehicle => ({
      value: vehicle.entityId,
      label: vehicle.vehicleNumber
    }))
    if (vehicleError) {
      this.setState({ vehicleDetails: [] })
    } else {
      this.setState({ vehicleDetails: allVehicles })
    }
  }

  handleChange = async event => {
    this.setState({ vehicleNumber: event.value })
    const { data } = await this.props.client.query({
      query: GET_CALIBRATION_DETAILS,
      variables: {
        entityId: parseInt(event.value, 10)
      },
      fetchPolicy: 'network-only'
    })

    if (data.getFuelCalibrationDetail) {
      this.setDetails(data.getFuelCalibrationDetail)
    } else {
      console.log('inside else condtion')
      this.setState({
        refuelThreshold: '3',
        drainThreshold: '0.5',
        medianFilter: '10',
        pfPerMin: '3',
        pilferageTolerance: '10',
        minimumPilferageDuration: '30',
        userType: '0',
        sensorType: 'Digital_sensor',
        minValue: '',
        maxValue: '',
        minCapacity: '',
        maxCapacity: '',
        totalFuelTank: '',
        fileName: '',
        bucketName: '',
        publicUploadURL: '',
        downloadUrl: ''
      })
    }
  }

  setDetails = vehicleDetail => {
    console.log('details', vehicleDetail)
    console.log('fuelUserType', vehicleDetail.fuelUserType)
    let fileName = ''
    let bucketName = ''
    let url = ''
    if (
      vehicleDetail.calibration_filename !== null ||
      vehicleDetail.calibration_filename !== undefined
    ) {
      fileName = vehicleDetail.calibration_filename
      bucketName = 'aquila-track-uploads'
    }

    if (vehicleDetail.url !== null || vehicleDetail.url !== undefined) {
      url = vehicleDetail.url
    }
    this.setState({
      refuelThreshold: vehicleDetail.refuelThreshold,
      drainThreshold: vehicleDetail.drainThreshold,
      medianFilter: vehicleDetail.medianFilter,
      pfPerMin: vehicleDetail.pfPerMin,
      pilferageTolerance: vehicleDetail.pilferageTolerance,
      minimumPilferageDuration: vehicleDetail.minimumPilferageDuration,
      userType: JSON.stringify(vehicleDetail.fuelUserType),
      sensorType: vehicleDetail.fuelSensorType,
      minValue: vehicleDetail.minValue,
      maxValue: vehicleDetail.maxValue,
      minCapacity: vehicleDetail.minTankCapacity,
      maxCapacity: vehicleDetail.maxTankCapacity,
      totalFuelTank: vehicleDetail.totalFuelTank,
      fileName: fileName,
      bucketName: bucketName,
      publicUploadURL: url,
      downloadUrl: url
    })
  }

  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }

  handleChangeType = event => {
    //console.log(event.target.value, 'typ')
    this.setState({ sensorType: event.target.value })
    // console.log(this.state.sensorType, event.target.value, 'typ')
  }

  handleUserChangeType = event => {
    this.setState({ userType: event.target.value })
    // console.log(this.state.userType, event.target.value, 'typ')
  }

  getClients = async () => {
    let data = await this.props.client.query({
      query: GET_PARTNER_CLIENT_LIST,
      variables: {
        partnerLoginId: getLoginId()
      },
      fetchPolicy: 'network-only'
    })

    const allClients = data.data.clientsDetails.map(client => ({
      value: client.loginId,
      label: client.clientName
    }))
    this.setState({ clientNames: allClients })
  }

  onUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    this.setState({ isUploading: true })
    if (validity.valid) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })

      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        await axios.put(url, file)
        let { data } = await this.props.client.query({
          query: GET_FILE_FORMAT,
          variables: {
            bucketname: response.data.getPublicUploadURL.bucketName,
            filename: response.data.getPublicUploadURL.filename
          },
          errorPolicy: 'all'
        })
        console.log('data.getPublicDownloadURL', data.getPublicDownloadURL)
        this.setState({
          fileName: response.data.getPublicUploadURL.filename,
          bucketName: response.data.getPublicUploadURL.bucketName,
          publicUploadURL: response.data.getPublicUploadURL.publicUploadURL,
          downloadUrl: data.getPublicDownloadURL
        })
      }
    }
    this.setState({ isUploading: false })
  }

  handleSubmit = async event => {
    this.setState({ isLoading: true })
    const { data, errors } = await this.props.client.mutate({
      mutation: ADD_VEHICLES,
      variables: {
        fileInfo: {
          uploadFor: 'uploadFileToFuelCalibrationTable',
          bucketName: this.state.bucketName,
          fileName: this.state.fileName,
          operationType: 'SKIP'
        },
        commonInput: {
          clientLoginId: parseInt(this.state.clientname, 10),
          //partnerLoginId: getLoginId(),
          // manufacturerCode: this.state.manufacturer.code
          fuelInputs: {
            vehicleId: parseInt(this.state.vehicleNumber, 10),
            fuelSensorType: this.state.sensorType,
            minTankCapacity: parseInt(this.state.minCapacity, 10),
            minValue: parseInt(this.state.minValue, 10),
            maxTankCapacity: parseInt(this.state.maxCapacity, 10),
            totalFuelTank: parseInt(this.state.totalFuelTank, 10),
            maxValue: parseInt(this.state.maxValue, 10),
            fuelUserType: 1,
            refuelThreshold: parseInt(this.state.refuelThreshold, 10),
            drainThreshold: parseFloat(this.state.drainThreshold, 10),
            medianFilter: parseInt(this.state.medianFilter, 10),
            pfPerMin: parseFloat(this.state.pfPerMin, 10),
            pilferageTolerance: parseFloat(this.state.pilferageTolerance, 10),
            minimumPilferageDuration: parseFloat(
              this.state.minimumPilferageDuration,
              10
            )
          }
        }
      },
      errorPolicy: 'all'
    })
    this.setState({ isLoading: false })
    if (data) {
      let fullData = []

      let arrList = data.excelFileUpload.failedUploadList

      JSON.parse(arrList).forEach(element => {
        var rowData = []
        rowData.push(element.serialNumber)
        rowData.push(element.error)

        fullData.push(rowData)
      })
      // console.log(data)
      this.setState({
        response:
          'Total Excel Records= ' +
          data.excelFileUpload.totalExcelDataRecords +
          ',' +
          'Total Records Uploaded=' +
          data.excelFileUpload.successfullyUploaded +
          ', Total Records Failed To Upload=' +
          data.excelFileUpload.failedToUpload +
          ', Total Duplicate Records in Excel=' +
          data.excelFileUpload.totalDuplicateRecords,
        uploadSucess: true,
        failList: fullData,
        result: true
      })
      console.log('Res:', this.state.response)
    } else {
      this.setState({ response: errors[0].message, uploadSucess: true })
      console.log('Res ss:', this.state.response)
    }
  }

  checkMinCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isminCapacityValid:
        regex.test(this.state.minCapacity) || this.state.minCapacity === ''
    })
  }
  checkMaxCapacityValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      ismaxCapacityValid:
        regex.test(this.state.maxCapacity) || this.state.maxCapacity === ''
    })
  }
  checkTotalFuelTankValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      isTotalFuelTankValid:
        regex.test(this.state.totalFuelTank) || this.state.totalFuelTank === ''
    })
  }

  checkMinValueValidity = () => {
    const regex = new RegExp(/^[0-9]{1,3}$/)
    this.setState({
      isminValueValid:
        regex.test(this.state.minValue) || this.state.minValue === ''
    })
  }
  checkMaxValueValidity = () => {
    const regex = new RegExp(/^[0-9]{2,5}$/)
    this.setState({
      ismaxValueValid:
        regex.test(this.state.maxValue) || this.state.maxValue === ''
    })
  }

  componentDidMount() {
    this.getClients(this.props.client)
  }

  downloadBulkUpload = client => async event => {
    console.log('click fun')
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'Fuelcalibration.xlsx'
      },
      errorPolicy: 'all'
    })
    console.log('file', data.getPublicDownloadURL)
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Typography variant="subtitle1" gutterBottom>
          <h2>Fuel Calibration</h2>
        </Typography>
        <Grid container spacing={16}>
          <Grid container xs={12}>
            <Grid item xs={6}>
              <Grid item xs={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <Select
                    classes={classes}
                    options={this.state.clientNames}
                    // components={components}
                    value={this.state.clientname}
                    onChange={this.handleClientChange}
                    placeholder="Select Client *"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                {' '}
                <br />
                Download sample to generate fuel calibration equation
              </Grid>
              <br />
              <Grid item xs={12}>
                <Button
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                  onClick={this.downloadBulkUpload(this.props.client)}
                >
                  Download Excel
                </Button>
              </Grid>
              {/* Upload Button */}
              <Grid item xs={12} sm={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  {/* <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="A0"
                      name="A0"
                      className="textfield"
                      margin="dense"
                      label="A^0 :"
                      // type="Multi-line"
                      value={this.state.A0}
                      required
                      onChange={this.handleInputChange('A0')}
                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                  </FormGroup>
                </FormControl> */}
                  <br />
                  <input
                    accept="*/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{
                      display: 'none'
                    }}
                    onChange={this.onUpload}
                  />
                  <label htmlFor="contained-button-file">
                    Upload excel file here &nbsp;
                    <Button
                      variant="contained"
                      component="span"
                      color="primary"
                    >
                      {this.state.isUploading ? (
                        <CircularProgress size={15} />
                      ) : (
                        'Upload'
                      )}
                    </Button>
                  </label>
                </FormControl>
              </Grid>{' '}
              <br />
              {this.state.fileName == '' || this.state.fileName == null ? (
                <Grid item xs={12} sm={12} style={{ color: '#cccccc' }}>
                  No File Selected File Format - XLS, XLSX
                </Grid>
              ) : (
                <Grid item xs={12} sm={12}>
                  Uploaded excel file:{' '}
                  <a
                    href={this.state.downloadUrl}
                    style={{
                      // color: '#cccccc',
                      // textDecoration: 'none',
                      fontSize: '16px'
                    }}
                  >
                    Click Here
                  </a>
                </Grid>
              )}
              <br />
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="refuelThreshold"
                      name="refuelThreshold"
                      className="textfield"
                      margin="dense"
                      label="Refuel Threshold(L) :"
                      // type="Multi-line"
                      value={this.state.refuelThreshold}
                      required
                      onChange={this.handleInputChange('refuelThreshold')}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="drainThreshold"
                      name="drainThreshold"
                      className="textfield"
                      margin="dense"
                      label="Drain Threshold(L):"
                      // type="Multi-line"
                      value={this.state.drainThreshold}
                      required
                      onChange={this.handleInputChange('drainThreshold')}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="medianFilter"
                      name="medianFilter"
                      className="textfield"
                      margin="dense"
                      label="Median Filter:"
                      // type="Multi-line"
                      value={this.state.medianFilter}
                      required
                      onChange={this.handleInputChange('medianFilter')}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>

                  <FormGroup className="form-input">
                    <TextField
                      id="pfPerMin"
                      name="pfPerMin"
                      className="textfield"
                      margin="dense"
                      label="Pilferage Per Min(L):"
                      // type="Multi-line"
                      value={this.state.pfPerMin}
                      required
                      onChange={this.handleInputChange('pfPerMin')}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>

                  {/* <FormGroup className="form-input">
                    <TextField
                      id="pilferageTolerance"
                      name="pilferageTolerance"
                      className="textfield"
                      margin="dense"
                      label="Pilferage Tolerance(%):"
                      // type="Multi-line"
                      value={this.state.pilferageTolerance}
                      required
                      onChange={this.handleInputChange('pilferageTolerance')}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    /> */}

                  {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}

                  <FormGroup className="form-input">
                    <TextField
                      id="minimumPilferageDuration"
                      name="minimumPilferageDuration"
                      className="textfield"
                      margin="dense"
                      label="Minimum Pilferage Duration(sec)"
                      // type="Multi-line"
                      value={this.state.minimumPilferageDuration}
                      required
                      onChange={this.handleInputChange(
                        'minimumPilferageDuration'
                      )}

                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12}>
                <br />
                {/* <FormControl component="fieldset">
                  <FormLabel component="legend">Fuel User Type:*</FormLabel>
                  <RadioGroup
                    aria-label="userType"
                    className={classes.group}
                    name="userType"
                    value={this.state.userType}
                    onChange={this.handleUserChangeType}
                    row
                  >
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="Ominicom User"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Normal User"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl> */}
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12}>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <Select
                    classes={classes}
                    options={this.state.vehicleDetails}
                    // components={components}
                    value={this.state.vehicleNumber}
                    onChange={this.handleChange}
                    placeholder="Select Vehicle *"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="minCapacity"
                      name="minCapacity"
                      className="textfield"
                      margin="dense"
                      label="Min Tank Capacity :"
                      // type="Multi-line"
                      value={this.state.minCapacity}
                      required
                      onChange={this.handleInputChange('minCapacity')}
                      error={!this.state.isminCapacityValid}
                      onBlur={this.checkMinCapacityValidity}
                    />

                    <FormHelperText id="name-error-text" className="Error_msg">
                      {!this.state.isminCapacityValid &&
                        'Min capacity should be integer between 1-999'}
                    </FormHelperText>
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="maxCapacity"
                      name="maxCapacity"
                      className="textfield"
                      margin="dense"
                      label="Max Tank Capacity :"
                      // type="Multi-line"
                      value={this.state.maxCapacity}
                      required
                      onChange={this.handleInputChange('maxCapacity')}
                      error={!this.state.ismaxCapacityValid}
                      onBlur={this.checkMaxCapacityValidity}
                    />

                    <FormHelperText id="name-error-text" className="Error_msg">
                      {!this.state.ismaxCapacityValid &&
                        'Max capacity should be integer between 10-99999'}
                    </FormHelperText>
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="totalFuelTank"
                      name="totalFuelTank"
                      className="textfield"
                      margin="dense"
                      label="Total Fuel Tank :"
                      // type="Multi-line"
                      value={this.state.totalFuelTank}
                      required
                      onChange={this.handleInputChange('totalFuelTank')}
                      error={!this.state.isTotalFuelTankValid}
                      onBlur={this.checkTotalFuelTankValidity}
                    />

                    <FormHelperText id="name-error-text" className="Error_msg">
                      {!this.state.isTotalFuelTankValid &&
                        'Total Fuel Tank should be integer between 10-99999'}
                    </FormHelperText>
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="minValue"
                      name="minValue"
                      className="textfield"
                      margin="dense"
                      label="Min Value :"
                      // type="Multi-line"
                      value={this.state.minValue}
                      required
                      onChange={this.handleInputChange('minValue')}
                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>
                </FormControl>
              </Grid>{' '}
              <Grid item xs={12} sm={12} fullwidth>
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      id="maxValue"
                      name="maxValue"
                      className="textfield"
                      margin="dense"
                      label="Max Value :"
                      // type="Multi-line"
                      value={this.state.maxValue}
                      required
                      onChange={this.handleInputChange('maxValue')}
                      // error={!this.state.isVlpnValid}
                      // onBlur={this.checkVlpnValidity(this.props.client)}
                    />

                    {/* <FormHelperText id="name-error-text" className="Error_msg">
                  {!this.state.isVlpnValid ? this.state.vlpnres : ''}
                </FormHelperText> */}
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <br />
                <FormControl component="fieldset">
                  <FormLabel component="legend">Fuel Sensor Type:*</FormLabel>
                  <RadioGroup
                    aria-label="sensorType"
                    className={classes.group}
                    name="sensorType"
                    value={this.state.sensorType}
                    onChange={this.handleChangeType}
                    row
                  >
                    <FormControlLabel
                      value="Digital_sensor"
                      control={<Radio />}
                      label="Digital Sensor Type"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Analog_sensor"
                      control={<Radio />}
                      label="Analog Sensor Type"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.handleSubmit}
              disabled={
                this.state.clientname === '' ||
                this.state.vehicleNumber === '' ||
                this.state.refuelThreshold === '' ||
                this.state.drainThreshold === '' ||
                this.state.medianFilter === '' ||
                this.state.pfPerMin === '' ||
                this.state.pilferageTolerance === '' ||
                this.state.minimumPilferageDuration === '' ||
                this.state.userType === '' ||
                this.state.minValue === '' ||
                this.state.minCapacity === '' ||
                this.state.maxValue === '' ||
                this.state.maxCapacity === '' ||
                this.state.totalFuelTank === '' ||
                this.state.sensorType === ''
              }
            >
              SUbmit
            </Button>{' '}
            <Button
              color="default"
              variant="outlined"
              size="medium"
              margin="normal"
              className="btn"
              onClick={() => this.props.history.goBack()}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.result == true ? (
              <Typography variant="subtitle1" gutterBottom>
                Data Saved Successfully!!!
              </Typography>
            ) : (
              <Typography variant="subtitle1" gutterBottom>
                {this.state.response}
              </Typography>
            )}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(FuelCalibration))
)



// WEBPACK FOOTER //
// ./src/components/Pages/FuelCalibration/index.jsx